import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateProviderInput!) {
    createProvider (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/NewMutation.js